<template>
    <div class='step step1'>
        <div class='background' :style="{backgroundImage: 'url('+require('@/assets/img/background_h.png')+')'}"></div>
        <div class='intro'>
            <div class='left_side btm_align'>
                <h1 :class="{show: showTitle}">DIGITAL CAN UNLOCK MASSIVE VALUE</h1>
                <transition name='fade'>
                    <div v-if='showBtn' @click='$parent.nextStep("step2")' class='btn'>
                        <div>
                        <p>Next Step </p>
                        <img class='arr' src='@/assets/img/arr.svg'>
                        </div>
                    </div>
                </transition>
            </div>
            <div :class="{show: showRight}" class='right_side'>
                <div class='stats'>
                    <div class='stat'>
                        <div class='svg_holder'>
                            <svg  viewBox="0 0 40.65 36.66">
                                <line x1="36.65" y1="36.66" x2="36.65" style="fill: none;stroke: #8dae6e;stroke-miterlimit: 10;stroke-width: 8px"/>
                                <line x1="25.77" y1="36.66" x2="25.77" y2="9.16" style="fill: none;stroke: #8dae6e;stroke-miterlimit: 10;stroke-width: 8px"/>
                                <line x1="14.88" y1="36.66" x2="14.88" y2="18.33" style="fill: none;stroke: #8dae6e;stroke-miterlimit: 10;stroke-width: 8px"/>
                                <line x1="4" y1="36.66" x2="4" y2="27.49" style="fill: none;stroke: #8dae6e;stroke-miterlimit: 10;stroke-width: 8px"/>
                            </svg>
                        </div>
                        <p class='info'>up to 4x speed to market with agile</p>
                    </div>
                    <div class='stat'>
                        <div class='svg_holder'>
                            <svg viewBox="0 0 39.66 19.83">
                                <path d="M54,27.2a18.33,18.33,0,0,1-36.66,0" transform="translate(-15.84 -27.2)" style="fill: none;stroke: #8dae6e;stroke-miterlimit: 10;stroke-width: 3px"/>
                            </svg>
                            <p>50%</p>
                        </div>
                        <p class='info'>50% reduction in R&D lifecycle time</p>
                    </div>
                    <div class='stat'>
                        <div class='svg_holder'>
                            <svg viewBox="0 0 39.66 39.66">
                                <path d="M54,27.2A18.33,18.33,0,1,1,35.67,8.87" transform="translate(-15.84 -7.37)" style="fill: none;stroke: #8dae6e;stroke-miterlimit: 10;stroke-width: 3px"/>
                            </svg>
                            <p>75%</p>
                        </div>
                        <p class='info'>up to 75% capacity released with digitized shared services</p>
                    </div>
                </div>
            </div>
        </div> 
    </div>
</template>

<script>
const fb = require("@/firebaseConfig.js");
const db = fb.default.db;
var moment = require("moment");

export default {
  name: "step1",
  data(){
    return {
      showTitle: false,
      showRight: false,
      showBtn: false
    }
  },
  created(){
    setTimeout(()=> {
        this.showTitle = true;
        setTimeout(()=> {
            this.showStats();
        }, 500);

        setTimeout(()=> {
            this.showBtn = true;
        }, 7000);
    }, 1000);
  },
  methods: {
    showStats(){
        let time = -2000;
        let stats = document.getElementsByClassName('stat');
        for(var i=0; i<stats.length; i++) {
            time += 2500;
            let index = i;
            setTimeout(function(){
                stats[(stats.length-1)-index].classList.add('show');
            }, time);
        }
    }
  }
}
</script>
